/**
 * 서비스 워커는 데스크톱 알림 클릭(notificationclick)만 맡는다 — public/sw.js. 캐시·웹 푸시는 하지 않는다.
 * 예전(Go 서버 시절) workbox 서비스 워커가 app.html 을 캐시해 두었으므로, 새 sw.js 가 설치되며 그 캐시를 비운다.
 * 새 배포 감지는 VersionChecker(index.html 비교)가 한다.
 */
const registerSW = () => {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) {
    return;
  }
  navigator.serviceWorker.register("/sw.js").catch((e) => {
    console.error("[ServiceWorker] Registration error:", e);
  });
};

export default registerSW;
